export default __webpack_public_path__ + "static/media/Ballroll_00309.e89d58a5.png";